import cloneDeep from 'lodash/cloneDeep';

import {
  ACTIVATE_MODAL,
  DISMISS_MODAL
} from './modal-manager-actions';

export default function (state = [], action) {
  switch (action.type) {
    case ACTIVATE_MODAL: {
      const newState = cloneDeep(state);
      newState.push(action.modal);
      return newState;
    }
    case DISMISS_MODAL: {
      const newState = cloneDeep(state);
      newState.pop();
      return newState;
    }
    default:
      break;
  }

  return state;
}
